import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";

export const Reveal = ({ children, i = 0, className = "" }) => (
  <motion.div
    className={className}
    variants={fadeUp}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={viewportOnce}
  >
    {children}
  </motion.div>
);
